import React from 'react';
import './Cards.css';
import CardItem from './CardItem';



function Cards() {
  return (
    <div className='cards'>
        
      <h1>Professional React.js WebApps</h1>
    
      <div className='cards__container'>
        <div className='cards__wrapper'>
          <ul className='cards__items'>
            <CardItem
              src='http://jsxcode.com/reactapps/mainapps/React-images/React-amazon-clone.png'
              text='Amazon-Clone
              This is basically a clone of the well-known E-commerce website Amazon. 
              It uses Firebase for User Authentication.
              What is Special about this Build ?
              Well I used three  different styling techniques to design its different Components
              React bootstrap React-styled-components for the footer and CSS for most of the components '
              label='React.js'
              path='//jsxcode.com/reactapps/amazon-firestore/'
              target='_blank' 
            />
            <CardItem
              src='http://jsxcode.com/reactapps/mainapps/React-images/React-multi-theme-calculator-app.png'
              text='A React.js Calculator with multi theme available to choose from.
              Perform mathematical operations like addition, subtraction, multiplication, and division; Adjust the color theme based on their preference'
              label='React.js'
              path='//jsxcode.com/reactapps/React-Multi-Theme-calculator-app'
              target='_blank' 
             
            />
          </ul>

          <ul className='cards__items'>
            <CardItem
              src='http://jsxcode.com/reactapps/mainapps/React-images/React-Webaites.png'
              text='React Responsive Website Using Styled Components with Smooth Scroll. 
              See it yourself….now. 
              I built this responsive website in React Hooks and React Router for this project.'
              label='React.js'
              path='//jsxcode.com/reactapps/react-master-website-app'
              target='_blank' 
            />
            <CardItem
              src='http://jsxcode.com/reactapps/mainapps/React-images/Whack A Mole-Game.png'
              text='I created a whack a mole game with React.js Using Hooks and Router'
              label='React.js'
              path='//jsxcode.com/jsxcode/reactapps/molegame/'
              target='_blank' 
             
            />
            <CardItem
              src='http://jsxcode.com/reactapps/mainapps/React-images/React-navbar-dropdownApp.png'
              text='React Responsive Navigation Menu and Dropdown Using Hooks and Router'
              label='React.js'
              path='//jsxcode.com/reactapps/navbar-dropdown-app'
              target='_blank' 
             
            />
          </ul>

          <ul className='cards__items'>
            <CardItem
              src='http://jsxcode.com/reactapps/mainapps/React-images/React-stylecomponent.png'
              text='React Responsive Website Using Hooks and Router with Reusable Components'
              label='React.js'
              path='//jsxcode.com/reactapps/react-mainapps'
              target='_blank' 
            />
            <CardItem
              src='http://jsxcode.com/reactapps/mainapps/React-images/React-formApp.png'
              text='React SIGN UP Form | API Integration Ready.
              I created a simple form with react hooks and included validation'
              label='react.js'
              path='//jsxcode.com/reactapps/react-form-app'
              target='_blank' 
            />
            <CardItem
              src='http://jsxcode.com/reactapps/mainapps/React-images/React-counterApp.png'
              text='React Responsive  Counter used bootstrap and font-awesome.'
              label='React.js'
              path='//jsxcode.com/reactapps/counter-app'
              target='_blank' 
            />

          </ul>
          <ul className='cards__items'>
         
          <CardItem
              src='http://jsxcode.com/reactapps/mainapps/React-images/React-calculatorApp.png'
              text=' Responsive  React Calculator App'
              label='React.js'
              path='//jsxcode.com/reactapps/calculator-app'
              target='_blank' 
            />
            <CardItem
              src='http://jsxcode.com/reactapps/mainapps/React-images/React-todolistApp.png'
              text=' Responsive  React ToDoList App'
              label='React.js'
              path='//jsxcode.com/reactapps/todolist-app'
              target='_blank' 
            /> 
           
           <CardItem
           
    
              src='http://jsxcode.com/reactapps/mainapps/React-images/HTMLCSSJS.png'
              text=' Responsive  HTML CSS and Javascript Website with Smooth Scroll'
              label='T-Websites'
              
              path='//jsxcode.com/code'
              target='_blank' 
                > </CardItem>
              
           


            </ul>
        </div>
      </div>
    </div>
  );
}

export default Cards;
